<template>
  <div class="page-content">
    <portal to="layout-nav-title">{{$t('wechatMiniProgram.analysis.summaryAndVisitPage')}}</portal>

    <el-date-picker
      v-model="endDate"
      type="date"
      @change="dateChange"
      :picker-options="pickerOptions"
      :placeholder="$t('wechatMiniProgram.analysis.pleaseSelectDate')">
    </el-date-picker>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="page_path" :label="$t('wechatMiniProgram.analysis.pagePath')" width="200"> </el-table-column>
      <el-table-column prop="page_visit_pv" :label="$t('wechatMiniProgram.analysis.pageVisitPv')" width="100"> </el-table-column>
      <el-table-column prop="page_visit_uv" :label="$t('wechatMiniProgram.analysis.pageVisitUv')" width="100"> </el-table-column>
      <el-table-column prop="page_staytime_pv" :label="$t('wechatMiniProgram.analysis.pageStaytimePv')" width="100"> </el-table-column>
      <el-table-column prop="entrypage_pv" :label="$t('wechatMiniProgram.analysis.entrypagePv')" width="100"> </el-table-column>
      <el-table-column prop="exitpage_pv" :label="$t('wechatMiniProgram.analysis.exitpagePv')" width="100"> </el-table-column>
      <el-table-column prop="page_share_pv" :label="$t('wechatMiniProgram.analysis.pageSharePv')" width="100"> </el-table-column>
      <el-table-column prop="page_share_uv" :label="$t('wechatMiniProgram.analysis.pageShareUv')" width="100"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class VisitPage extends Vue {
  tableData = [];
  endDate = moment().add('days', -1);

  get pickerOptions() {
    return {
      disabledDate: (time) => {
        return moment(time).diff(moment(new Date()), 'days') > -1;
      }
    }
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    this.tableData = await this.$request.get('/wechat_third_party_platform/data_analysis/visit_page', params);
  }

  dateChange() {
    if (this.endDate) {
      this.fetchData({ begin_date: moment(this.endDate).subtract(7, 'd').format('YYYY-MM-DD'), end_date: this.endDate });
    } else {
      this.$message.warning(this.$t('wechatMiniProgram.analysis.pleaseSelectDate'));
    }
  }
}

export const route = [
  {
    path: '/visit_page',
    name: 'visit_page',
    component: VisitPage,
    meta: {
      can: 'data_analyses.visit_page'
    }
  },
]
</script>

<style lang="scss" scoped>
  .page-content {
    margin: 20px 0 0 20px;
  }

  /deep/ .el-date-editor {
    margin-bottom: 20px;
  }
</style>
